import React from 'react';
import { bool, func, element, string } from 'prop-types';
import FormDialog from '../../../../../shared/ui/FormDialog/FormDialog';

const defaultPropDialog = {
  disableTextField: true,
  hideButtons: true,
};

function CalculatingTransportWindow({ isOpen, onClose, title, children }) {
  return (
    <FormDialog {...defaultPropDialog} title={title} open={isOpen} handleClose={onClose} dialogContent={children} />
  );
}

CalculatingTransportWindow.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  title: string.isRequired,
  children: element.isRequired,
};

export default React.memo(CalculatingTransportWindow);
